module.exports = __webpack_public_path__ + "img/74.fca7cb05.png";